import { Utils } from "./utils";

export class LogoUtils {
    static getLogo(url: string, maxWidth: number = 250): Promise<{ base64: string; width: number; height: number } | null> {
      
      if(Utils.isNullOrEmpty(url)) return new Promise((resolve, reject) => {
        resolve(null)
        return
      })
      
      return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'Anonymous'; // Needed for cross-origin images
      
          img.onload = () => {
            let width = img.width;
            let height = img.height;
      
            // Scale proportionally if width exceeds maxWidth
            if (width > maxWidth) {
              const scale = maxWidth / width;
              width = maxWidth;
              height = Math.round(height * scale);
            }
      
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
      
            const ctx = canvas.getContext('2d');
            if (!ctx) {
              reject('Could not get canvas context');
              return
            }
      
            ctx.drawImage(img, 0, 0, width, height);
      
            const base64 = canvas.toDataURL('image/png').split(',')[1]; // strip "data:image/png;base64,"
            resolve({
              base64,
              width,
              height
            });
          };
      
          img.onerror = (err) => {
            reject(`Failed to load image from ${url}`);
          };
      
          img.src = url;
        });
      }
}